import * as THREE from "three";
import SolidGeometry from "./solid-geometry";

// Eixo em y: base (largura x profundidade) embaixo e ponta no topo
export default class ConeGeometry extends SolidGeometry {
  constructor(color, { width, height, depth }, positions) {
    const geometry = new THREE.ConeGeometry(0.5, 1, 64);
    geometry.scale(width, height, depth);
    super("cone", color, geometry, positions);
  }
}
